import Navbar from '@/components/layout/Navbar';
import VehiclesSection from '@/components/sections/VehiclesSection';
import Footer from '@/components/layout/Footer';
import WhatsAppFloat from '@/components/common/WhatsAppFloat';
import { useEffect } from 'react';
import fleetBanner from '@/assets/fleet-banner.png';

const Vehicles = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src={fleetBanner}
            alt="Our Luxury Fleet"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-slate-900/60" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-slate-900/40" />
        </div>

        {/* Content */}
        <div className="container relative z-10 px-4 text-center pt-20">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 animate-fade-up text-white">
            Our Premium <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">Fleet</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto animate-fade-up stagger-1">
            Choose from our wide range of well-maintained vehicles for a comfortable and safe journey.
          </p>
        </div>
      </section>

      <main>
        <VehiclesSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default Vehicles;
